import { Theme } from '@mui/material'
import { makeStyles } from '@mui/styles'
import { getRGBA } from 'utils/color'

const useStyles = makeStyles((theme: Theme) => ({
  headerContainer: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: '1rem',
  },

  headerBack: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-start',
    gap: '1rem',
    padding: 0,

    '& h1': {
      fontFamily: 'Sora',
      fontWeight: '400',
      fontSize: '1.5rem',
      lineHeight: '2rem',
      color: '#000000',
    },
  },

  headerInfoContainer: {
    width: '100%',
    display: 'flex',
    alignItems: 'start',
    gap: '3rem',
    textAlign: 'left',
    fontFamily: 'Nunito',
    fontWeight: '400',
    fontSize: '0.875rem',
    lineHeight: '1.25rem',
    color: '#8B8D97',
  },

  itemsContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '0.8rem',
    alignItems: 'start',
  },

  connectorsContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'start',
  },

  badgeContainer: {
    display: 'flex',
    gap: '0.5rem',
    alignItems: 'center',
  },

  connector: {
    textAlign: 'left',
    fontFamily: 'Sora',
    fontWeight: 'bold',
    fontSize: '1.25rem',
    lineHeight: '0rem',
    color: '#191C1A',
  },

  expirationDate: {
    textAlign: 'left',
    fontFamily: 'Sora',
    fontSize: '1.25rem',
    lineHeight: '2rem',
    color: ' #191C1A',
  },

  connectors: {
    display: 'flex',
    flexDirection: 'row',
  },

  tags: {
    display: 'flex',
    flexDirection: 'row',
    gap: '0.5rem',
    marginTop: '-1rem',
  },

  containnerBase: {
    padding: '0 0.5rem',
    display: 'flex',
    flexDirection: 'row',
    gap: '3rem',
    marginBottom: '1rem',
  },

  containerInfo: {
    display: 'flex',
    gap: '1rem',
    alignItems: 'center',
  },

  groupText: {
    display: 'flex',
    flexDirection: 'column',
    gap: '0rem',

    '& span': {
      fontFamily: 'Nunito',
      fontWeight: '400',
      fontSize: '0.875rem',
      lineHeight: '1.25rem',
      color: '#191C1A',
      padding: 0,
      margin: 0,
    },
  },

  title: {
    fontFamily: 'Nunito',
    fontWeight: '400 !important',
    fontSize: '0.75rem !important',
    lineHeight: '1.25rem !important',
    color: '#8B8D97',
  },

  subTitle: {
    fontFamily: 'Nunito',
    fontWeight: '400 !important',
    fontSize: '0.75rem !important',
    lineHeight: '1.25rem !important',
    color: `${getRGBA('#0F0F1E', 0.6)}  !important`,
  },
}))

export { useStyles }
